const red        = "#f44336";
const pink       = "#f44336";
const purple     = "#e91e63";
const deepPurple = "#9c27b0";
const indigo     = "#673ab7";
const blue       = "#3f51b5";
const lightBlue  = "#2196f3";
const cyan       = "#03a9f4";
const teal       = "#00bcd4";
const green      = "#009688";
const lightGreen = "#4caf50";
const lime       = "#8bc34a";
const yellow     = "#cddc39";
const amber      = "#ffeb3b";
const orange     = "#ffc107";
const deepOrange = "#ff9800";

export const COLORS = [
  red, purple, indigo, lightBlue, teal, lightGreen, yellow, orange,
  pink, deepPurple, blue, cyan, green, lime, amber, deepOrange
];
